import { i18n } from '@/plugins/i18n'
import { invertKeyValues } from '@/common/objects'
import { CommissionConversionType, CommissionStatus } from '@/constants'

export const conversionTypes = invertKeyValues(CommissionConversionType)

export const statuses = invertKeyValues(CommissionStatus)

export const conversionTypeStr = (conversionType) => {
    return i18n.t('commission.conversion_types.'+conversionTypes[conversionType])
}

export const statusStr = (status) => {
    const str = statuses[status].toLowerCase()

    return i18n.t('commission.statuses.'+str)
}

export const statusColor = (status) => {
    if(status === CommissionStatus.ACTIVE) {
        return 'success'
    }

    return 'danger'
}